var _style, _rect, _circle, _circle2, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle3, _circle4, _circle5, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2, _path0, _path1, _path10;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRemoveVehicle = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e60940b9-1d3a-4f50-92ff-a0dc71c5b8ba",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFB6B6;}\r\n\t.st2{opacity:0.5;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.6;fill:url(#SVGID_3_);enable-background:new    ;}\r\n\t.st6{fill:#FFD7D7;}\r\n\t.st7{fill:#FF5151;}\r\n\t.st8{fill:url(#SVGID_4_);}\r\n\t.st9{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st10{fill:url(#SVGID_5_);}\r\n\t.st11{fill:url(#SVGID_6_);}\r\n\t.st12{fill:url(#SVGID_7_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 200,
    height: 200
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.7,
    cy: 100,
    r: 75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -6096.0103,
    y1: 35.76,
    x2: -5946.0103,
    y2: 35.76,
    gradientTransform: "matrix(6.123234e-17 -1 -1 -6.123234e-17 135.46 -5921.0103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FFD0D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FF5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5151"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 99.7,
    cy: 100,
    r: 75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.7,
    y1: -6423.1001,
    x2: 99.7,
    y2: -6353.0005,
    gradientTransform: "matrix(1 0 0 -1 0 -6328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8F9FC",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.2,95.1l49.2-1.1l7.4-61.8c-20.3-9.6-43.9-9.6-64.2,0L75.2,95.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.8,99H48.6c-2.7,0-4.9-2.2-4.9-4.9V61.9c0-2.7,2.2-4.9,4.9-4.9h102.2c2.7,0,4.9,2.2,4.9,4.9v32.2 C155.7,96.8,153.5,99,150.8,99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.7,
    y1: -6385,
    x2: 99.7,
    y2: -6427,
    gradientTransform: "matrix(1 0 0 -1 0 -6328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FFF1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#FFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#FFC6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB6B6"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M150.8,99H48.6c-2.7,0-4.9-2.2-4.9-4.9V61.9c0-2.7,2.2-4.9,4.9-4.9h102.2c2.7,0,4.9,2.2,4.9,4.9v32.2 C155.7,96.8,153.5,99,150.8,99z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7,
    y: 83,
    className: "st6",
    width: 100,
    height: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7,
    y: 63,
    className: "st7",
    width: 19,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7,
    y: 67,
    className: "st7",
    width: 19,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7,
    y: 71,
    className: "st6",
    width: 19,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7,
    y: 78,
    className: "st6",
    width: 100,
    height: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7,
    y: 92,
    className: "st4",
    width: 14,
    height: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7,
    y: 92,
    className: "st4",
    width: 6,
    height: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 108.3,
    cy: 51.6,
    r: 2.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 80.2,
    cy: 42.6,
    r: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 120,
    cy: 34,
    r: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M144.7,132.8h-1.8V131c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3v1.8h-1.8c-0.7,0-1.3,0.6-1.3,1.3 s0.6,1.3,1.3,1.3h1.8v1.8c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3v-1.8h1.8c0.7,0,1.3-0.6,1.3-1.3 C146,133.4,145.5,132.8,144.7,132.8C144.8,132.8,144.7,132.8,144.7,132.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.2,122.1H60v-1.2c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0,0,0,0,0v1.2H57c-0.5,0-0.9,0.4-0.9,0.9 s0.4,0.9,0.9,0.9h1.2v1.2c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-1.2h1.2c0.5,0,0.9-0.4,0.9-0.9S61.7,122.1,61.2,122.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.65,
    y1: -6432.7002,
    x2: 99.65,
    y2: -6485.0005,
    gradientTransform: "matrix(1 0 0 -1 0 -6328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE5050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6000F"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M114.1,157H85.4c-2,0-3.6-1.5-3.9-3.4l-5.9-48.9h48.1l-5.9,48.9C117.7,155.5,116,157,114.1,157z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.1,148.6L89.1,148.6c-1.1,0-2-0.8-2.1-1.9l-2.8-32.5c-0.1-1.2,0.8-2.2,2-2.3c0,0,0.1,0,0.1,0l0,0 c1.1,0,2,0.8,2.1,1.9l2.8,32.5c0.1,1.2-0.7,2.2-1.9,2.3C89.2,148.6,89.2,148.6,89.1,148.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M110.4,148.6L110.4,148.6c-1.2,0-2.1-0.9-2.1-2.1c0-0.1,0-0.1,0-0.2l2.8-32.5c0.1-1.1,1-1.9,2.1-1.9l0,0 c1.2,0,2.1,0.9,2.1,2.1c0,0.1,0,0.1,0,0.2l-2.8,32.5C112.4,147.8,111.5,148.6,110.4,148.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M99.7,148.6L99.7,148.6c-1.1,0-2.1-0.9-2.1-2c0,0,0-0.1,0-0.1v-32.4c0-1.1,0.9-2.1,2-2.1c0,0,0.1,0,0.1,0l0,0 c1.1,0,2.1,0.9,2.1,2c0,0,0,0.1,0,0.1v32.4c0,1.1-0.9,2.1-2,2.1C99.8,148.6,99.7,148.6,99.7,148.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "123.4,108.1 76.1,108.1 76.1,108.6 123.3,108.6  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "118.1,152.5 81.4,152.5 81.5,153 118,153  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.4706,
    y1: -6426.6221,
    x2: 125.3006,
    y2: -6412.4922,
    gradientTransform: "matrix(1 0 0 -1 0 -6328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE5050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6000F"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M127,94.4L112.6,90h-0.1l-17.3-5.3l0,0l-14.6-4.5c-1.5-0.5-3.2,0.4-3.7,1.9c0,0,0,0.1,0,0.1l-1.3,4.2l52,16 l1.3-4.2C129.4,96.6,128.6,94.9,127,94.4C127,94.4,127,94.4,127,94.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.0122,
    y1: -6415.2974,
    x2: 109.9622,
    y2: -6411.6074,
    gradientTransform: "matrix(1 0 0 -1 0 -6328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE5050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6000F"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M100.3,85.6c0.9-1.6,2.8-2.4,4.6-1.9c1.8,0.6,2.9,2.3,2.8,4.2l3.1,0.9c0.7-3.9-1.8-7.6-5.7-8.3 c-3.2-0.6-6.4,1.1-7.8,4.1L100.3,85.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.48,
    y1: -6396.0479,
    x2: 61.81,
    y2: -6396.0479,
    gradientTransform: "matrix(1 0 0 -1 0 -6328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE5050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED1828"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M61.4,65.6h-1.9l-1-1.8c-0.3-0.5-0.8-0.7-1.3-0.7H53c-0.5,0-1,0.3-1.3,0.7l-1,1.8h-1.9 c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4l0,0H50c0.1,0,0.1,0.1,0,0.1c-0.5,0.2-0.8,0.7-0.8,1.3v2.6c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.1,0.1,0.3,0.1,0.5v0.8c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0h1.5c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0v-0.7 c0-0.2,0.2-0.4,0.4-0.4h4.5c0.2,0,0.4,0.2,0.4,0.4v0.7c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0H60c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0 v-0.8c0-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.2-0.4,0.2-0.6v-2.6c0-0.6-0.3-1.1-0.8-1.3c-0.1,0,0-0.1,0-0.1h1.2c0.2,0,0.4-0.2,0.4-0.4 C61.8,65.8,61.6,65.6,61.4,65.6z M51.5,69.7h-1.1c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0,0h1.1 c0.2,0,0.3,0.1,0.3,0.3C51.8,69.5,51.7,69.7,51.5,69.7C51.5,69.7,51.5,69.7,51.5,69.7z M57.3,70.6h-4.6c-0.1,0-0.1-0.1-0.1-0.2 l0.6-0.6c0.2-0.2,0.5-0.3,0.8-0.3h1.7c0.3,0,0.7,0.1,0.8,0.3l0.6,0.6C57.4,70.5,57.4,70.6,57.3,70.6z M51.7,66.3 c-0.2,0-0.4-0.2-0.2-0.4l0.9-1.7c0.2-0.4,0.6-0.6,1-0.6h3.4c0.4,0,0.8,0.2,1,0.6l0.9,1.7c0.1,0.2,0,0.4-0.2,0.4H51.7z M60.4,69.4 c0,0.2-0.1,0.3-0.3,0.3H59c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h1.1C60.2,69,60.4,69.2,60.4,69.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemoveVehicle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/remove-vehicle.beba824b.svg";
export { ForwardRef as ReactComponent };